import { Component, Input } from '@angular/core';
import { News } from '../../../classes/classes';

@Component({
  selector: 'news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.sass']
})

export class NewsComponent {

  @Input() news_pool: News[];

  private newsList: HTMLCollectionOf<Element> = document.getElementsByClassName('newsArticle');
  private oldIndex: number = undefined;
  private timer: NodeJS.Timer;

  constructor() { 
  }


  private resetTimer() {
    clearTimeout(this.timer);
    this.timer = setInterval(() => {
      this.nextArticle();
    }, 7500);
  }

  public nextArticle() {
    this.oldIndex = 1;
    // this.resetTimer();
    for (let i = 0; i < this.news_pool.length; i++) {
      // find the active item
      if (this.newsList[i]) {
        if (this.newsList[i].classList.contains('active')) {
          // deactivate it
          this.newsList[i].classList.remove('active');
          // and store the index
          this.oldIndex = i;
        }
      }
    }

    

    // deactivate previous
    this.news_pool[this.oldIndex].isActive = false;
    // activate the selected
    if (this.news_pool[this.oldIndex + 1]) {
      this.news_pool[this.oldIndex + 1].isActive = true;
    }

    // remove and store the first item in array
    const shifted = this.news_pool.shift();
    // update the index
    shifted.index = this.news_pool[this.news_pool.length - 1].index + 1;
    // and append it
    this.news_pool.push(shifted);
  }

  public prevArticle(): void {
    this.oldIndex = 1;
    // this.resetTimer();

    for (let i = 0; i < this.news_pool.length; i++) {
      // find the active item
      if (this.newsList[i].classList.contains('active')) {
        // deactivate it
        this.newsList[i].classList.remove('active');
        // and store the index
        this.oldIndex = i;
      }
    }

    // deactivate previous
    this.news_pool[this.oldIndex].isActive = false;
    // activate the selected
    this.news_pool
    [this.oldIndex - 1].isActive = true;

    // remove and store the last item in array
    const poped = this.news_pool.pop();
    // update the index
    poped.index = this.news_pool[0].index - 1;
    // and prepend it
    this.news_pool.unshift(poped);
  }
}
